module.exports = __webpack_public_path__ + "img/graphql-artwork.757c4e69.png";